import { useEffect } from 'react'

const KNOWN_SLUGS = [
  'looky-demo',
]

/**
 * Хук для динамического подключения стилей витрин из папки css/apps
 * на основе slug витрины из URL. Загружает CSS через fetch запрос.
 */
export function useDynamicAppStyles(slug: string) {
  useEffect(() => {
    if (!slug || !KNOWN_SLUGS.includes(slug)) return

    const normalizedSlug = slug.toLowerCase()

    const styleId = `app-styles-${normalizedSlug}`
    if (document.getElementById(styleId)) {
      return
    }

    const loadStyles = async () => {
      try {
        const response = await fetch(`/css/apps/${normalizedSlug}.css`)
        if (!response.ok) {
          return
        }

        const cssContent = await response.text()

        const styleElement = document.createElement('style')
        styleElement.id = styleId
        styleElement.textContent = cssContent
        document.head.appendChild(styleElement)

        console.info(`Стили для витрины "${slug}" успешно загружены`)
      } catch (error) {
        console.error(error)
      }
    }

    void loadStyles()

    return () => {
      const existingStyle = document.getElementById(styleId)
      if (existingStyle) {
        existingStyle.remove()
      }
    }
  }, [slug])
}
